export var ASPECT_RATIO = 16 / 9;
export var DEFAULT_IFRAME_WIDTH = '560';
export var DEFAULT_IFRAME_HEIGHT = '315';